import React from 'react'
import ChangeCheckContext from "../support/ChangeCheckContext";

function FileUpload(props) {

    const latestProps = React.useRef(props.fileData);
    const fileInputRef = React.useRef(null);
    const dropRef = React.useRef(null);

    const {disable} = React.useContext(ChangeCheckContext)
    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        props.newFilesUpload(files, latestProps.current);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        props.newFilesUpload(files, latestProps.current);
    };

    React.useEffect(() => {
        latestProps.current = props.fileData;
    }, [props.fileData]);


    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDragEnter = (event) => {
        event.preventDefault();
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
    };

    React.useEffect(() => {
        const dropArea = dropRef.current;

        // Add drag and drop event listeners
        dropArea.addEventListener('drop', handleDrop);
        dropArea.addEventListener('dragover', handleDragOver);
        dropArea.addEventListener('dragenter', handleDragEnter);
        dropArea.addEventListener('dragleave', handleDragLeave);

        return () => {
            // Remove event listeners when component unmounts
            dropArea.removeEventListener('drop', handleDrop);
            dropArea.removeEventListener('dragover', handleDragOver);
            dropArea.removeEventListener('dragenter', handleDragEnter);
            dropArea.removeEventListener('dragleave', handleDragLeave);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div ref={dropRef} style={{ border: '2px dashed black', padding: '20px' }}>
                <button type="button" onClick={handleClick}>
                    Select Files
                </button>
                <input
                    disabled={disable}
                    type="file"
                    multiple
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                />
                Drop files here
            </div>
        </>
    )
}

export default FileUpload;